import React from "react"
export const Language = {
    en: {
        welcome: "Welcome",
        logout: "Logout",
        subtitle: "At a glance summary of your account.",
        recentList: "Recent Listing",
        recentPayment: "Recent Payments",
        havetotal: "You have total",
        records: "Records",
        goback: "Go Back",
        exportcsv: "Export CSV",
        view: "View",
        personalinfo: "Personal Information",
        selectuserstatus: "Select User Status",
        fullName: "Full Name",
        email: "Email",
        mobile: "Mobile",
        delete: "Delete",
        filter: "Filter",
        fromDate: "From Date",
        toDate: "To Date",
        viewedit: "View/Edit",
        view: "View",
        edit: "Edit",
        addNew: "Add New",
        saveChanges: "Save Changes",
        fillAll: "Fill all the required Fields",
        submit: "Submit",
        reset: "Reset",
        appName: "Application Name",
        appLogo: "Application Logo",
        favicon: "Favicon",
        adminLogo: "Admin Logo",
        appemail: "Application Email",
        address: "Contact Address",
        instagramLink: "Instagram Link",
        facebookLink: "Facebook Link",
        youtubeLink: "Youtube Link",
        whatsappLink: "Whatsapp Link",
        authTitle: "Auth Title",
        authInfo: "For Mobile App Login Screens",
        authTitle_ar: "Auth Title Arabic",
        authSubTitle: "Auth Subtitle",
        authSubTitle_ar: "Auth Subtitle Arabic",

        privacyLink: "Privacy Policy Link",
        termsLink: "Terms & Condition",
        inviteCreditMode: "Invite Credit Charging",
        inviteCreditModeDesc: "Controls when sending an invite uses a credit. Resending to the same guest is free.",
        creditModePerGuestPerType: "Charge once per guest & type (resend free)",
        creditModePerGuest: "Per guest, up to invitation passes (earlier sends prepay the rest)",
        creditModeInvitationOnly: "Only invitations use credits (reminders/save-the-dates free)",
        creditModePerMessage: "Charge every message (legacy)",
        whatsappProvider: "WhatsApp Sending API",
        whatsappProviderDesc: "Which service delivers invite WhatsApp messages. Facebook uses the approved templates from WhatsApp Manager (with the link button); WaSender sends free-form text with the event image.",
        providerWasender: "WaSender",
        providerFacebook: "Facebook (WhatsApp Cloud API)",
        update: "Update",
        paymentGateway: "Payment GateWay Setup",
        paymentClient: "Client Key",
        paymentSecret: "Client Secret Key",
        paymentMode: "Mode",
        updatePassword: "Update Password",
        newpassword: "New Password",
        newpassword1: "Confirm Password",
        siteSetting: "Site Setting",
        //PROEPRTY INFO
        propertyInfo: "Property Information",
        basics: "Basics",
        listingType: "Listing Type",
        category: "Category",
        propertyTitle: "Property Title",
        propertyLocation: "Property Location",
        country: "Country",
        viewOnMap: "View on Map",
        rentPrice: "Price",
        rentType: "Type",
        featuredAd: "Is Featured Ad ?",
        imageGallery: "Image & Video Gallery",
        propertyFeatures: "Property Features",
        video: "Video",
        images: "Images",
        features: "Features",
        //EVENT INFORMATION
        overview: "Overview",
        teams: "Assigned Users",
        groups: "Groups",
        league: "League Matches",
        sponser: "Sponsers",
        pointTable: "Point Table",
        knockouts: "Knockout Matches",
        eventInfo: "Event Information",
        yes: "Yes",
        no: "No",
        loadingTxt: "Loading....",
        //Toast Status
        userUpdate: "User Status Updated",
        errorTxt: "Error Occured Try Again",
        recordAdded: "Record Added Successfully",
        recordEdit: "Record Edited Successfully",
        recordDelete: "Record Deleted Successfully",
        propertyStatus: "Property Status Updated",
        notificationText: "Notification Sent Successfully",
        fileUploaded: "File Uploaded Successfully",
        settingUpdate: "Setting Updated Successfully",
        passwordUpdate: "Password Updated Successfully",
        //LOGIN PAGE
        emailAddress: "Email Address",
        password: "Password",
        signIn: "Sign in",
        adminSignIn: "Admin Sign-In",
        accessThe: "Access the",
        accessSub: "panel using your email and passcode.",
        otpverification: "OTP Verification",
        otpSub: "Enter the verification code we sent to",
        verifyOtp: "Verify OTP",
        didntget: "Didn’t get the code ?",
        resend: "Resend",
        otpResend: 'OTP Sent Successfully',
        enterOTP: "Enter the OTP",
        eventStatus: "Event Status Updated",
        //EVENT INFO
        eventInfo: "Event Information",
        eventSubHeading: "Basic information about the selected event.",
        category: "Category",
        eventName: "Event Name",
        location: "Location",
        viewOnMap: "View on Map",
        featuredEvent: "Featured Event",
        showOnSlider: "Show on Home Silder",
        viewBanner: "View Invitation",
        viewBannerPdf: "View Invitation (PDF)",
        description: "Description",
        additionInfo: "Additional Information",
        regPrice: "Registration Price",
        matchType: "Match Type",
        maxPlayer: "Max Player in a Team",
        maxTeams: "Maximum Teams",
        maxGroups: "Maximum Groups",
        startDate: "Event Start Date",
        registrationOpenDate: "Reg.Start Date",
        registrationCloseDate: "Reg.Close Date",
        date: "Date",
        courtNo: "Court No",
        group: "Group",
        updateCourtAndDate: "Update Date and Court No",
        mat: "Mat",
        won: "Won",
        lost: "Lost",
        tied: "Tied",
        pts: "Pts",
        round: "Round",
        updateScore: "Update Score",
        teamA: "Team A",
        teamB: "Team B",
        place: "Place",
        action: "Action",
        movetoKnockout: "Move to Knockout",
        beInteger: "Number should be an integer",
        viewplayers: "View Players",
        selectStatus: "Select Status",
        assignteam: "Assign Team",
        assignUpdate: "Team Assigned Successfully",
        announcement: "Announcement",
        title: "Title",
        message: "Message",
        notificationType: "Type",
        dob: "Date of Birth",
        civilID: "Civil ID",
        invites: "Invites",
        userName: "User Name",
        userMobile: "User Mobile No",
        status: "Status",
        description_ar: "Description Arabic",
        totalInvitation: "Total Invitation",
        remainingInvitation: "Remaining Invitation",
        totalInviteCount: "Total Invites",
        pendingInviteCount: "Pending Invites",
        accpetedInviteCount: "Accepted Invites",
        rejectedInviteCount: "Rejected Invites",
        inviteType: "Invite Type",
        remainderImage: "View Reminder",
        saveDateImage: "View Save the Date",
        remainderPdf: "View Reminder (PDF)",
        saveDatePdf: "View Save the Date (PDF)",
        count: "Count",
        enterCount: "Enter count",
        action: "Action",
        add: "Add",
        reduce: "Reduce",
        addCredits: "Add Credits",
        reduceCredits: "Reduce Credits",
        maxReduceNote: "Max reducible:",
        reason: "Reason",
        enterReason: "Enter reason (optional)",
        addCreditsBtn: "Add Credits",
        reduceCreditsBtn: "Reduce Credits",
        creditsNote: "Adding credits will increase both total and remaining counts. Reducing credits will decrease both counts but only if there are enough remaining credits available.",
        totalCredits: "Total Credits",
        usedCredits: "Used Credits",
        remainingCredits: "Remaining Credits",
        updateCredits: "Update Credits",
        // Event > Invites tab: filter / export / print
        allStatuses: "All statuses",
        allTypes: "All types",
        pendingStatus: "Pending",
        acceptedStatus: "Accepted",
        rejectedStatus: "Rejected",
        exportCsv: "Export CSV",
        printList: "Print",
        guests: "Guests",
        sentOn: "Sent On",
        showingRecords: "Showing",
        ofRecords: "of",
        invitesList: "Invites List",
        printedOn: "Printed on",
        invitationsSent: "Invitations Sent",
        confirmedAttendees: "Confirmed Attendees",
        checkedIn: "Checked In",
        remainingPasses: "Remaining Passes",
        seenInvite: "Seen",
        sentVia: "Sent Via",
        inviteLanguage: "Language",
        sentBy: "Sent By",
        declineReason: "Decline Reason",
        actions: "Actions",
        reopenInvite: "Reopen",
        reopenInviteResend: "Reopen & resend",
        confirmDialogCancel: "Cancel",
        reopenConfirmTitle: "Reopen invitation?",
        reopenResendConfirmTitle: "Reopen and resend?",
        revokeConfirmTitle: "Revoke invitation?",
        revokeConfirmYes: "Yes, revoke",
        reopenConfirm: "The guest will be able to answer again on the same link, and the invitation will be taken back out of the host's balance.",
        reopenConfirmResend: "The guest will be able to answer again, and the invitation will be sent to them again on the same link. It will be taken back out of the host's balance.",
        reopenDone: "Invitation reopened — the guest can answer again.",
        reopenDoneResent: "Invitation reopened and sent to the guest again.",
        reopenFailed: "Could not reopen this invitation.",
        revokeInvite: "Revoke",
        revokedStatus: "Revoked",
        revokeConfirm: "The link and QR code will stop working, so this guest can no longer see the invitation or enter with it. The credits return to the sender. This can't be undone, but you can send this number a new invitation later.",
        revokeDone: "Invitation revoked. The link and QR code no longer work.",
        revokeFailed: "Could not revoke this invitation.",
        reopenedTimes: "Reopened",
        bulkTitle: "Send to all guests",
        bulkInvitation: "Invitation",
        bulkReminder: "Reminder",
        bulkTheInvitation: "the invitation",
        bulkTheReminder: "the reminder",
        bulkWillReceive: "guests will receive {what}",
        bulkNoAnswer: "No answer",
        bulkAlreadyInvited: "Already have the invitation",
        bulkSendTo: "Send to",
        bulkAcceptedGuests: "Accepted guests",
        bulkNoAnswerGuests: "No answer guests",
        bulkDeclinedGuests: "Declined guests",
        bulkPassesPerGuest: "Passes per guest",
        bulkInvitationHint: "Goes to guests who got the Save the Date but no invitation yet, in the same language as their Save the Date.",
        bulkNobodyToInvite: "Everyone already has the invitation.",
        bulkNoTypes: "Neither the Invitation nor the Reminder is enabled for this event. Upload the Invitation or Reminder PDF in the event first.",
        bulkConfirmQuestion: "Send {what} to {n} guests now?",
        reminderButton: "Send to all guests",
        reminderTitle: "Send reminder to everyone",
        reminderLoading: "Working out who will receive it…",
        reminderLoadFailed: "Could not load the reminder details.",
        reminderSendFailed: "Could not send the reminders.",
        reminderWillReceive: "guests will receive the reminder",
        reminderWaiting: "Waiting for a reply",
        reminderAccepted: "Accepted",
        reminderDeclined: "Declined",
        reminderSkipped: "Not included",
        reminderSkipDeclined: "Declined",
        reminderSkipAccepted: "Already accepted",
        reminderSkipRecent: "Reminded in the last 24 hours",
        reminderSkipCheckedIn: "Already checked in",
        reminderSkipNoInvitation: "No invitation sent (Save the Date only)",
        reminderOptOnlyPending: "Only guests who haven't replied yet",
        reminderOptIncludeDeclined: "Include guests who declined",
        reminderOptIncludeRecent: "Send again to guests reminded in the last 24 hours",
        reminderSendVia: "Send via",
        reminderViaBoth: "Both",
        reminderCost: "Cost",
        reminderCredits: "credits",
        reminderTakes: "takes",
        reminderMinutes: "min",
        reminderNobody: "Nobody to remind with these options.",
        reminderLastRun: "Last run",
        reminderCancel: "Cancel",
        reminderSendTo: "Send to {n} guests",
        reminderConfirmQuestion: "Send the reminder to {n} guests now?",
        reminderBack: "Back",
        reminderYesSend: "Yes, send",
        reminderStarting: "Starting…",
        reminderSending: "Sending reminders…",
        reminderDone: "Finished",
        reminderCancelled: "Stopped",
        reminderSent: "Sent",
        reminderFailed: "Failed",
        reminderRemaining: "Remaining",
        reminderBackgroundNote: "You can close this window — sending continues in the background. Open it again to see progress.",
        reminderFailedList: "Not delivered",
        reminderStop: "Stop sending",
        reminderCancelConfirm: "Stop sending? Guests not reached yet will not get the reminder.",
        reminderRetry: "Retry failed",
        reminderClose: "Close",
        yes: "Yes",
        no: "No",
        totals: "Totals",
        totalInvitationsSent: "Invitations sent",
        totalAccepted: "Accepted",
        totalPending: "Pending",
        totalRejected: "Declined",
        totalCheckedIn: "Checked in",
        guestsLabel: "guests",
        // Invites tab: one row per guest vs. every message
        messagesSent: "Messages Sent",
        lastSentOn: "Last Sent",
        viewGrouped: "One row per guest",
        viewEachMessage: "Every message",
        typeInvitation: "Invitation",
        typeReminder: "Reminder",
        typeSaveDate: "Save the Date",
        guestsShown: "guests"
        









    },
    ar: {
        welcome: "مرحباً",
        logout: "تسجيل خروج",
        subtitle: "في لمحة ملخص حسابك.",
        recentList: "القائمة الأخيرة",
        recentPayment: "المدفوعات الأخيرة",
        havetotal: "لديك المجموع",
        records: "السجلات",
        goback: "عُد",
        exportcsv: "تصدير CSV",
        view: "منظر",
        personalinfo: "معلومات شخصية",
        selectuserstatus: "حدد حالة المستخدم",
        fullName: "الاسم الكامل",
        email: "بريد إلكتروني",
        mobile: "متحرك",
        delete: "يمسح",
        filter: "منقي",
        fromDate: "من التاريخ",
        toDate: "ان يذهب في موعد",
        viewedit: "معاينة ما تم تحريره",
        view: "منظر",
        edit: "يحرر",
        addNew: "اضف جديد",
        saveChanges: "حفظ التغييرات",
        fillAll: "املأ جميع الحقول المطلوبة",
        submit: "يُقدِّم",
        reset: "إعادة ضبط",
        appName: "اسم التطبيق",
        appLogo: "شعار التطبيق",
        favicon: "فافيكون",
        adminLogo: "شعار المسؤول",
        appemail: "البريد الإلكتروني للتطبيق",
        address: "عنوان الإتصال",
        instagramLink: "رابط Instagram",
        facebookLink: "رابط الفيسبوك",
        youtubeLink: "رابط يوتيوب",
        whatsappLink: "رابط الواتس اب",
        authTitle: "عنوان المصادقة",
        authInfo: "لشاشات تسجيل الدخول إلى تطبيقات الجوال",
        authTitle_ar: "عنوان العنوان العربي",
        authSubTitle: "الترجمة الفرعية",
        authSubTitle_ar: "الترجمة الفرعية العربية",

        privacyLink: "رابط سياسة الخصوصية",
        termsLink: "الشروط والشرط",
        inviteCreditMode: "احتساب رصيد الدعوات",
        inviteCreditModeDesc: "يتحكم في متى يخصم إرسال الدعوة رصيداً. إعادة الإرسال لنفس الضيف مجانية.",
        creditModePerGuestPerType: "خصم مرة واحدة لكل ضيف ونوع (إعادة الإرسال مجانية)",
        creditModePerGuest: "لكل ضيف حتى عدد بطاقات الدعوة (الإرسالات السابقة تُحتسب مقدماً)",
        creditModeInvitationOnly: "الدعوات فقط تستهلك الرصيد (التذكير وحفظ التاريخ مجاني)",
        creditModePerMessage: "خصم كل رسالة (النظام القديم)",
        whatsappProvider: "واجهة إرسال واتساب",
        whatsappProviderDesc: "الخدمة التي ترسل رسائل الدعوة عبر واتساب. فيسبوك يستخدم القوالب المعتمدة من مدير واتساب (مع زر الرابط)؛ واسيندر يرسل نصاً حراً مع صورة المناسبة.",
        providerWasender: "واسيندر",
        providerFacebook: "فيسبوك (WhatsApp Cloud API)",
        update: "تحديث",
        paymentGateway: "إعداد بوابة الدفع",
        paymentClient: "مفتاح العميل",
        paymentSecret: "المفتاح السري للعميل",
        paymentMode: "وضع",
        updatePassword: "تطوير كلمة السر",
        newpassword: "كلمة المرور الجديدة",
        newpassword1: "تأكيد كلمة المرور",
        siteSetting: "إعداد الموقع",
        //PROEPRTY INFO
        propertyInfo: "معلومات الملكية",
        basics: "الأساسيات",
        listingType: "نوع القائمة",
        category: "فئة",
        propertyTitle: "عنوان الممتلكات",
        propertyLocation: "موقع العقار",
        country: "دولة",
        viewOnMap: "عرض على الخريطة",
        rentPrice: " سعر",
        rentType: "يكتب",
        featuredAd: "هل الإعلان مميز؟",
        imageGallery: "معرض الصور والفيديو",
        propertyFeatures: "خصائص المنشأة",
        video: "فيديو",
        images: "الصور",
        features: "سمات",
        yes: "نعم",
        no: "لا",
        loadingTxt: "تحميل....",
        userUpdate: "تحديث حالة المستخدم",
        errorTxt: "حدث خطأ حاول مرة أخرى",
        recordAdded: "سجل أضيفت بنجاح",
        recordEdit: "سجل التحرير بنجاح",
        recordDelete: "سجل حذف بنجاح",
        propertyStatus: "تم تحديث حالة الخاصية",
        notificationText: "إرسال الإخطار بنجاح",
        fileUploaded: "تم رفع الملف بنجاح",
        settingUpdate: "ضبط التحديث بنجاح",
        passwordUpdate: "تم تحديث كلمة السر بنجاح",
        //LOGIN PAGE
        emailAddress: "عنوان البريد الإلكتروني",
        password: "كلمة المرور",
        signIn: "تسجيل الدخول",
        adminSignIn: "تسجيل الدخول",
        accessThe: "الوصول إلى",
        accessSub: "لوحة تستخدم بريدك الإلكتروني ورمز المرور.",
        otpverification: "التحقق من OTP",
        otpSub: "أدخل رمز التحقق الذي أرسلناه إليه",
        verifyOtp: "تحقق من OTP",
        didntget: "لم تحصل على الرمز؟",
        resend: "إعادة إرسال",
        otpResend: 'أرسل OTP بنجاح',
        enterOTP: "أدخل OTP",
        eventStatus: "تحديث حالة الحدث",
        //LEFT HEADER
        overview: "ملخص",
        teams: "المستخدمين المعينين",
        groups: "مجموعات",
        league: "مباريات الدوري",
        sponser: "الرعاة",
        pointTable: "جدول النقطة",
        knockouts: "مباريات خروج المغلوب",
        eventInfo: "دعوة معلومات",
        yes: "نعم",
        no: "لا",
        //EVENT INFO BASIC
        eventInfo: "دعوة معلومات",
        eventSubHeading: "المعلومات الأساسية حول الحدث المحدد.",
        category: "فئة",
        eventName: "اسم الحدث",
        location: "موقع",
        viewOnMap: "عرض على الخريطة",
        featuredEvent: "حدث مميز",
        showOnSlider: "عرض على منزلق المنزل",
        viewBanner: "عرض الدعوة",
        viewBannerPdf: "عرض دعوة (PDF)",
        description: "وصف",
        additionInfo: "معلومات إضافية",
        regPrice: "سعر التسجيل",
        matchType: "نوع مباراة",
        maxPlayer: "ماكس لاعب في فريق",
        maxTeams: "الفرق القصوى",
        maxGroups: "المجموعات القصوى",
        startDate: "تاريخ بدء الحدث",
        registrationOpenDate: "تاريخ ريج",
        registrationCloseDate: "تاريخ ريج",
        date: "تاريخ",
        courtNo: "المحكمة لا",
        group: "مجموعة",
        updateCourtAndDate: "تاريخ التحديث والمحكمة لا",
        mat: "حصيرة",
        won: "فاز",
        lost: "ضائع",
        tied: "ربط",
        pts: "نقاط",
        round: "دائري",
        updateScore: "تحديث درجة",
        teamA: "الفريق أ",
        teamB: "الفريق ب",
        place: "مكان",
        action: "فعل",
        movetoKnockout: "انتقل إلى خروج المغلوب",
        beInteger: "يجب أن يكون الرقم عددًا صحيحًا",
        viewplayers: "عرض اللاعبين",
        selectStatus: "حدد الحالة",
        assignteam: "تعيين الفريق",
        assignUpdate: "تم تعيين الفريق بنجاح",
        announcement: "إعلان",
        title: "عنوان",
        message: "رسالة",
        notificationType: "يكتب",
        dob: "تاريخ الميلاد",
        civilID: "الهوية المدنية",
        invites: "يدعو",
        userName: "اسم المستخدم",
        userMobile: "رقم جوال المستخدم",
        status: "حالة",
        description_ar: "الوصف العربي",
        totalInvitation: "دعوة كاملة",
        remainingInvitation: "دعوة متبقية",
        inviteType: "دعوة النوع",
        remainderImage: "عرض الباقي",
        saveDateImage: "عرض حفظ التاريخ",
        remainderPdf: "عرض الباقي (PDF)",
        saveDatePdf: "عرض حفظ التاريخ (PDF)",
        count: "العدد",
        enterCount: "أدخل العدد",
        action: "الإجراء",
        add: "إضافة",
        reduce: "تقليل",
        addCredits: "إضافة ائتمانات",
        reduceCredits: "تقليل الائتمانات",
        maxReduceNote: "الحد الأقصى للتخفيض:",
        reason: "السبب",
        enterReason: "أدخل السبب (اختياري)",
        addCreditsBtn: "إضافة ائتمانات",
        reduceCreditsBtn: "تقليل الائتمانات",
        creditsNote: "سيؤدي إضافة الائتمانات إلى زيادة العدّادين الإجمالي والمتبقين. وسيؤدي تقليل الائتمانات إلى تقليل كلا العدّادين ولكن فقط إذا كان هناك ما يكفي من الائتمانات المتبقية.",
        totalCredits: "إجمالي الائتمانات",
        usedCredits: "الائتمانات المستخدمة",
        remainingCredits: "الائتمانات المتبقية",
        // Event > Invites tab: filter / export / print
        allStatuses: "جميع الحالات",
        allTypes: "جميع الأنواع",
        pendingStatus: "بانتظار الرد",
        acceptedStatus: "مقبول",
        rejectedStatus: "معتذر",
        exportCsv: "تصدير CSV",
        printList: "طباعة",
        guests: "عدد الحضور",
        sentOn: "تاريخ الإرسال",
        showingRecords: "عرض",
        ofRecords: "من",
        invitesList: "قائمة الدعوات",
        printedOn: "تمت الطباعة في",
        invitationsSent: "عدد الدعوات المرسلة",
        confirmedAttendees: "عدد الحضور المؤكد",
        checkedIn: "تم الحضور",
        remainingPasses: "الدعوات المتبقية",
        seenInvite: "تمت المشاهدة",
        sentVia: "طريقة الإرسال",
        inviteLanguage: "اللغة",
        sentBy: "أرسلت بواسطة",
        declineReason: "سبب الاعتذار",
        actions: "إجراءات",
        reopenInvite: "إعادة فتح",
        reopenInviteResend: "إعادة فتح وإرسال",
        confirmDialogCancel: "رجوع",
        reopenConfirmTitle: "إعادة فتح الدعوة؟",
        reopenResendConfirmTitle: "إعادة الفتح والإرسال؟",
        revokeConfirmTitle: "إلغاء الدعوة؟",
        revokeConfirmYes: "نعم، إلغاء الدعوة",
        reopenConfirm: "سيتمكن الضيف من الرد مرة أخرى على نفس الرابط، وسيتم خصم الدعوة من رصيد صاحب المناسبة.",
        reopenConfirmResend: "سيتمكن الضيف من الرد مرة أخرى، وسيتم إرسال الدعوة إليه مجددًا على نفس الرابط. وسيتم خصم الدعوة من رصيد صاحب المناسبة.",
        reopenDone: "تمت إعادة فتح الدعوة — يمكن للضيف الرد مرة أخرى.",
        reopenDoneResent: "تمت إعادة فتح الدعوة وإرسالها إلى الضيف مرة أخرى.",
        reopenFailed: "تعذر إعادة فتح هذه الدعوة.",
        revokeInvite: "إلغاء الدعوة",
        revokedStatus: "ملغاة",
        revokeConfirm: "سيتوقف الرابط ورمز QR عن العمل، فلن يتمكن هذا الضيف من رؤية الدعوة أو الدخول بها. ويعود الرصيد إلى المرسل. لا يمكن التراجع عن ذلك، لكن يمكنك إرسال دعوة جديدة لهذا الرقم لاحقًا.",
        revokeDone: "تم إلغاء الدعوة. الرابط ورمز QR لم يعودا يعملان.",
        revokeFailed: "تعذر إلغاء هذه الدعوة.",
        reopenedTimes: "أُعيد فتحها",
        bulkTitle: "إرسال لجميع الضيوف",
        bulkInvitation: "دعوة",
        bulkReminder: "تذكير",
        bulkTheInvitation: "الدعوة",
        bulkTheReminder: "التذكير",
        bulkWillReceive: "ضيف سيستلم {what}",
        bulkNoAnswer: "لم يرد",
        bulkAlreadyInvited: "لديهم الدعوة بالفعل",
        bulkSendTo: "إرسال إلى",
        bulkAcceptedGuests: "الضيوف المقبولين",
        bulkNoAnswerGuests: "الضيوف الذين لم يردوا",
        bulkDeclinedGuests: "الضيوف المعتذرين",
        bulkPassesPerGuest: "عدد الدعوات لكل ضيف",
        bulkInvitationHint: "تُرسل للضيوف الذين استلموا حفظ الموعد ولم تصلهم الدعوة بعد، وبنفس لغة حفظ الموعد.",
        bulkNobodyToInvite: "جميع الضيوف لديهم الدعوة بالفعل.",
        bulkNoTypes: "لم يتم تفعيل الدعوة أو التذكير لهذه المناسبة. يرجى رفع ملف PDF للدعوة أو التذكير في المناسبة أولاً.",
        bulkConfirmQuestion: "إرسال {what} إلى {n} ضيف الآن؟",
        reminderButton: "إرسال لجميع الضيوف",
        reminderTitle: "إرسال تذكير للجميع",
        reminderLoading: "جارٍ تحديد المستلمين…",
        reminderLoadFailed: "تعذر تحميل تفاصيل التذكير.",
        reminderSendFailed: "تعذر إرسال التذكيرات.",
        reminderWillReceive: "ضيف سيستلم التذكير",
        reminderWaiting: "بانتظار الرد",
        reminderAccepted: "مقبول",
        reminderDeclined: "معتذر",
        reminderSkipped: "غير مشمولين",
        reminderSkipDeclined: "معتذر",
        reminderSkipAccepted: "قبلوا الدعوة",
        reminderSkipRecent: "تم تذكيرهم خلال آخر 24 ساعة",
        reminderSkipCheckedIn: "تم تسجيل حضورهم",
        reminderSkipNoInvitation: "لم تُرسل لهم دعوة (حفظ الموعد فقط)",
        reminderOptOnlyPending: "فقط الضيوف الذين لم يردوا بعد",
        reminderOptIncludeDeclined: "تضمين الضيوف المعتذرين",
        reminderOptIncludeRecent: "الإرسال مرة أخرى لمن تم تذكيرهم خلال آخر 24 ساعة",
        reminderSendVia: "الإرسال عبر",
        reminderViaBoth: "كلاهما",
        reminderCost: "التكلفة",
        reminderCredits: "دعوات",
        reminderTakes: "يستغرق",
        reminderMinutes: "دقيقة",
        reminderNobody: "لا يوجد من يمكن تذكيره بهذه الخيارات.",
        reminderLastRun: "آخر إرسال",
        reminderCancel: "إلغاء",
        reminderSendTo: "إرسال إلى {n} ضيف",
        reminderConfirmQuestion: "إرسال التذكير إلى {n} ضيف الآن؟",
        reminderBack: "رجوع",
        reminderYesSend: "نعم، أرسل",
        reminderStarting: "جارٍ البدء…",
        reminderSending: "جارٍ إرسال التذكيرات…",
        reminderDone: "اكتمل",
        reminderCancelled: "تم الإيقاف",
        reminderSent: "تم الإرسال",
        reminderFailed: "فشل",
        reminderRemaining: "المتبقي",
        reminderBackgroundNote: "يمكنك إغلاق هذه النافذة — يستمر الإرسال في الخلفية. افتحها مرة أخرى لمتابعة التقدم.",
        reminderFailedList: "لم يتم التسليم",
        reminderStop: "إيقاف الإرسال",
        reminderCancelConfirm: "إيقاف الإرسال؟ الضيوف الذين لم يصلهم التذكير بعد لن يستلموه.",
        reminderRetry: "إعادة المحاولة للفاشلة",
        reminderClose: "إغلاق",
        yes: "نعم",
        no: "لا",
        totals: "الإجماليات",
        totalInvitationsSent: "الدعوات المرسلة",
        totalAccepted: "مقبول",
        totalPending: "بانتظار الرد",
        totalRejected: "معتذر",
        totalCheckedIn: "تم الحضور",
        guestsLabel: "ضيف",
        // Invites tab: one row per guest vs. every message
        messagesSent: "الرسائل المرسلة",
        lastSentOn: "آخر إرسال",
        viewGrouped: "صف واحد لكل ضيف",
        viewEachMessage: "كل رسالة",
        typeInvitation: "دعوة",
        typeReminder: "تذكير",
        typeSaveDate: "حفظ الموعد",
        guestsShown: "ضيف"






    }
}